import React, { Component } from "react"
import PropTypes from 'prop-types'
import { Alert, Card, CardBody, Col, Container, Row } from "reactstrap"
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import { AvField, AvForm } from "availity-reactstrap-validation"
import { apiError, loginUser } from "../../store/actions"
import profile from "../../assets/images/profile-img.png"
import realtyspacelogo from "../../assets/images/realtyspace.png"
import lightlogo from "../../assets/images/logo-light.svg"
import loginImg from "../../assets/img/broker-login.png"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "components/VerticalLayout/Footer"
import FooterLogin from "components/VerticalLayout/FooterLogin"
import Cookies from "js-cookie"
class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showPassword: false,
       rememberMe: false,
        email: "",
      password: "",
    }
    this.handleValidSubmit = this.handleValidSubmit.bind(this)
  }
  togglePassword = () => {
    this.setState((prev) => ({ showPassword: !prev.showPassword }));
  };
  handleValidSubmit(event, values) {
     const { rememberMe } = this.state
    this.props.loginUser(values, this.props.history)
  }
 componentDidMount() {
    this.props.apiError("")
    const savedEmail = Cookies.get("rememberEmail")
    const rememberMe = Cookies.get("rememberMe") === "true"

    if (rememberMe && savedEmail) {
      this.setState({
        email: savedEmail,
        rememberMe: true,
      })
    }
  }

   handleValidSubmit(event, values) {
    const { rememberMe } = this.state

    if (rememberMe) {
      Cookies.set("rememberEmail", values.email, { expires: 15 })
      Cookies.set("rememberMe", "true", { expires: 15 })
    } else {
      Cookies.remove("rememberEmail")
      Cookies.remove("rememberMe")
    }
    this.props.loginUser(values, this.props.history)
  }
 
 handleRememberMeChange = e => {
    this.setState({ rememberMe: e.target.checked })
  }


  render() {

 const { showPassword, email, password, rememberMe } = this.state
    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
        <div className="account-pages">
          <Container>
            <Row className="justify-content-center align-items-center vh-100">
              <Col md={10}>
                <div className="overflow-hidden my-5">

                  <CardBody className="pt-4">
                    <Row>

                      <Col lg={4}>
                        <div className="login-heading">
                          <h1>Broker Login</h1>
                        </div>
                        <div className="p-2">
                          <AvForm
                            className="form-horizontal"
                            method="post"
                            onValidSubmit={this.handleValidSubmit}
                          >
                            {this.props.error && this.props.error ? (
                              <Alert color="danger">{this.props.error}</Alert>
                            ) : null}
                            <div className="form-group mb-3 label-white">
                              <AvField
                                name="email"
                                label="Email Address"
                                value={email}
                                className="form-control border-r-50"
                                placeholder="Enter email"
                                type="email"
                                required
                              />
                            </div>
                            <div className="mb-3 label-white position-relative">
                              <AvField
                                name="password"
                                label="Password"
                                value={password}
                                placeholder="Enter Password"
                                className="form-control border-r-50"
                                type={showPassword ? "text" : "password"}
                                required
                              />
                              <span
                                onClick={this.togglePassword}
                                style={{
                                  position: "absolute",
                                  top: "38px",
                                  right: "10px",
                                  cursor: "pointer",
                                  color: "#666",
                                }}
                              >
                                {showPassword ? <i className="far fa-eye" /> : <i className="far fa-eye-slash" />}
                              </span>
                            </div>
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="customControlInline"
                                checked={rememberMe}
                                onChange={this.handleRememberMeChange}
                              />
                              <label
                                className="form-check-label text-white"
                                htmlFor="customControlInline"
                              >
                                Remember me
                              </label>
                            </div>

                            <div className="mt-3 d-grid">
                              <button
                                className="btn btn-login btn-block"
                                type="submit"
                              >
                                Submit
                              </button>
                            </div>

                            <div className="mt-4 text-white">
                              <Link to="/forgot-password" className="text-white">
                                <i className="mdi mdi-lock me-1" /> Forgot your
                                password?
                              </Link>
                            </div>
                          </AvForm>
                        </div>
                      </Col>
                      <Col lg={2}></Col>
                      <Col md={6} lg={6} xl={5}>
                        <img src={loginImg} className="img-fluid" />
                      </Col>
                    </Row>

                  </CardBody>
                </div>

              </Col>

            </Row>
          </Container>

          <FooterLogin />
        </div>
      </React.Fragment>
    )
  }
}

Login.propTypes = {
  apiError: PropTypes.any,
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,

}

const mapStateToProps = state => {
  const { error } = state.Login
  return { error }
}

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError })(Login)
)